import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Box, Tag, IconTick } from "braid-design-system";
import { useSkillsMatchSignedInContext } from "../../../JobDetailsView/JobDetailsView.mjs";
import { overflow } from "../SkillsMatchSignedIn.css.mjs";
const UnselectableQualities = ({
  id,
  qualities,
  isExpanded
}) => {
  const { limit } = useSkillsMatchSignedInContext();
  const displayedQualities = qualities == null ? void 0 : qualities.slice(0, limit);
  const hiddenQualities = qualities == null ? void 0 : qualities.slice(limit, qualities.length);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    displayedQualities == null ? void 0 : displayedQualities.map((item) => /* @__PURE__ */ jsx(
      Box,
      {
        className: overflow,
        children: /* @__PURE__ */ jsx(Tag, { size: "small", icon: /* @__PURE__ */ jsx(IconTick, {}), children: item.keyword.text })
      },
      `${id}-${item.keyword.ontologyId}`
    )),
    isExpanded && (hiddenQualities == null ? void 0 : hiddenQualities.map((item) => /* @__PURE__ */ jsx(
      Box,
      {
        className: overflow,
        children: /* @__PURE__ */ jsx(Tag, { size: "small", icon: /* @__PURE__ */ jsx(IconTick, {}), children: item.keyword.text })
      },
      `${id}-${item.keyword.ontologyId}`
    )))
  ] });
};
export {
  UnselectableQualities
};
